import { Fragment } from 'react';
import './NoteTips.scss';

export default function NoteTips({ list, isPc }) {
  if (!list || !list.length) return null;

  const showChildren = (tip) => (
    <>
      {tip.img && <img className="banner-note-tip-img" src={tip.img} alt="" />}
      {tip.label && <span className="banner-note-tip-label">{tip.label}</span>}
    </>
  );
  return (
    <div className="banner-note-tips-list">
      {list.map((tip, index) => (
        <div key={`note-tip-${index}`} className="banner-note-tip">
          {index > 0 && <div className="banner-note-tip-divider" />}
          <div className="banner-note-tip-inner">
            {isPc ? <div className="banner-note-tip-top">{showChildren(tip)}</div> : showChildren(tip)}
            {tip.value != null && <span className="banner-note-tip-value">{tip.value}</span>}
          </div>
        </div>
      ))}
    </div>
  );
}
